"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    textField: {
      '& .MuiInputBase-root': {
        alignItems: 'normal'
      },
      alignItems: 'normal'
    },
    thinTextField: {
      '& .MuiOutlinedInput-root': {
        padding: '5px'
      }
    },
    paddedChips: {
      backgroundColor: '#1E87771A',
      color: '#1E8777',
      marginRight: '8px',
      marginBottom: '8px'
    },
    chips: {
      backgroundColor: '#1E87771A',
      color: '#1E8777',
      marginRight: '8px',
      marginBottom: '2px'
    },
    deleteIcon: {
      color: '#1E8777',
      '&:hover': {
        color: '#1E877780'
      }
    }
  };
}, {
  name: 'AutoComplete'
});
exports.useStyles = useStyles;